import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["method", "action"]
const _hoisted_2 = {
  key: 0,
  class: "product-review-form__step--1"
}
const _hoisted_3 = { class: "product-review-form__header" }
const _hoisted_4 = { class: "product-review-form__headline" }
const _hoisted_5 = { class: "form__group--row" }
const _hoisted_6 = { class: "form__col-12" }
const _hoisted_7 = {
  key: 0,
  class: "form__group--row"
}
const _hoisted_8 = { class: "form__col-12" }
const _hoisted_9 = { class: "form__group" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "form__group" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "form__group" }
const _hoisted_14 = { class: "form__group" }
const _hoisted_15 = {
  key: 1,
  class: "product-review-form__section"
}
const _hoisted_16 = { class: "form__group" }
const _hoisted_17 = { class: "product-review-form__vote-text | form__text" }
const _hoisted_18 = { class: "winefinder__carousel__item-icon" }
const _hoisted_19 = { class: "winefinder__carousel__item-name" }
const _hoisted_20 = { class: "winefinder__carousel__item-icon" }
const _hoisted_21 = { class: "winefinder__carousel__item-name" }
const _hoisted_22 = { class: "product-review-form__buttons" }
const _hoisted_23 = { class: "product-review-form__disclaimer | form__text" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 0,
  class: "form__mandatory-text-block"
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 1,
  class: "product-review-form__step--2"
}
const _hoisted_28 = { class: "product-review-form__thankyou" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "product-review-form__ty-subline" }
const _hoisted_33 = {
  href: "/account/reviews/",
  class: "button button--primary"
}
const _hoisted_34 = { class: "product-review-form__ty-subline" }
const _hoisted_35 = {
  href: "/account/reviews/",
  class: "button button--primary"
}
const _hoisted_36 = { class: "product-review-form__ty-teaser" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "product-review-form__ty-subline" }
const _hoisted_39 = {
  href: "/registeraccount/",
  class: "button button--primary"
}
const _hoisted_40 = { class: "product-review-form__ty-teaser" }
const _hoisted_41 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ratings = _resolveComponent("ratings")!
  const _component_select_vue = _resolveComponent("select-vue")!
  const _component_text_input = _resolveComponent("text-input")!
  const _component_vote_input = _resolveComponent("vote-input")!
  const _component_options_list_input = _resolveComponent("options-list-input")!
  const _component_captcha_input = _resolveComponent("captcha-input")!

  return (_ctx.step > 0)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        id: "product-review-form",
        class: "product-review-form | form",
        onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitReview && _ctx.submitReview(...args)), ["prevent"])),
        ref: "reviewForm",
        method: _ctx.method,
        action: _ctx.action,
        novalidate: ""
      }, [
        (_ctx.step === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("header", _hoisted_3, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('ads.reviews.form.headline')), 1 /* TEXT */),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_ratings, {
                      class: _normalizeClass(["product-review-form__ratings", {'product-review-form__ratings--vintages': _ctx.initialModel.vintageOptions.length}]),
                      ratings: [{value: 1}, {value: 2}, {value: 3}, {value: 4}, {value: 5}],
                      rating: 0,
                      required: true,
                      "required-error": _ctx.$t('ads.reviews.form.ratingError'),
                      type: "input",
                      name: "rating_stars",
                      ref: "rating",
                      onChange: _ctx.onRatingChange
                    }, null, 8 /* PROPS */, ["class", "required-error", "onChange"])
                  ])
                ]),
                _cache[16] || (_cache[16] = _createTextVNode()),
                (_ctx.initialModel.vintageOptions.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_select_vue, {
                          class: "product-review-form__vintage",
                          name: "vintage",
                          modelValue: _ctx.model.vintage,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.vintage) = $event)),
                          options: _ctx.initialModel.vintageOptions,
                          "initial-value": _ctx.model.vintage
                        }, null, 8 /* PROPS */, ["modelValue", "options", "initial-value"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _cache[29] || (_cache[29] = _createTextVNode()),
              _createElementVNode("section", null, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_text_input, {
                    class: "product-review-form__input",
                    modelValue: _ctx.model.author,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.author) = $event)),
                    name: "author",
                    type: "text",
                    label: _ctx.$t('ads.reviews.form.author'),
                    disabled: !_ctx.isAuthorEditable,
                    required: !!_ctx.validations.model.author.required,
                    error: _ctx.getErrorText(_ctx.v$.model.author.$errors),
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.model.author.$touch()))
                  }, null, 8 /* PROPS */, ["modelValue", "label", "disabled", "required", "error"]),
                  _cache[17] || (_cache[17] = _createTextVNode()),
                  (!_ctx.isAuthorEditable && _ctx.$t('ads.reviews.form.author.helptext'))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "product-review-form__input-hint | form__text",
                        innerHTML: _ctx.$t('ads.reviews.form.author.helptext', ['/account/username/change/'])
                      }, null, 8 /* PROPS */, _hoisted_10))
                    : _createCommentVNode("v-if", true)
                ]),
                _cache[19] || (_cache[19] = _createTextVNode()),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_text_input, {
                    class: "product-review-form__input",
                    modelValue: _ctx.model.email,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.email) = $event)),
                    name: "email",
                    type: "email",
                    label: _ctx.$t('ads.reviews.form.email'),
                    required: !!_ctx.validations.model.email.required,
                    disabled: _ctx.isUserLoggedIn && !!_ctx.initialModel.email,
                    error: _ctx.getErrorText(_ctx.v$.model.email.$errors),
                    onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.model.email.$touch()))
                  }, null, 8 /* PROPS */, ["modelValue", "label", "required", "disabled", "error"]),
                  _cache[18] || (_cache[18] = _createTextVNode()),
                  (_ctx.$t('ads.reviews.form.email.helptext'))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "product-review-form__input-hint | form__text",
                        innerHTML: _ctx.$t('ads.reviews.form.email.helptext')
                      }, null, 8 /* PROPS */, _hoisted_12))
                    : _createCommentVNode("v-if", true)
                ]),
                _cache[20] || (_cache[20] = _createTextVNode()),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_text_input, {
                    class: "product-review-form__input",
                    modelValue: _ctx.model.title,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.title) = $event)),
                    name: "title",
                    type: "text",
                    label: _ctx.$t('ads.reviews.form.title'),
                    required: !!_ctx.validations.model.title.required,
                    error: _ctx.getErrorText(_ctx.v$.model.title.$errors),
                    onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.model.title.$touch()))
                  }, null, 8 /* PROPS */, ["modelValue", "label", "required", "error"])
                ]),
                _cache[21] || (_cache[21] = _createTextVNode()),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_text_input, {
                    class: "product-review-form__input roduct-review-form__textarea",
                    modelValue: _ctx.model.message,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.message) = $event)),
                    name: "message",
                    type: "textarea",
                    label: _ctx.$t('ads.reviews.form.message'),
                    required: !!_ctx.validations.model.message.required,
                    error: _ctx.getErrorText(_ctx.v$.model.message.$errors),
                    onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.model.message.$touch()))
                  }, null, 8 /* PROPS */, ["modelValue", "label", "required", "error"])
                ])
              ]),
              _cache[30] || (_cache[30] = _createTextVNode()),
              (_ctx.initialModel.wine && _ctx.settings.productReview.useRecommendationSection)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["product-review-form__section-toggle", {
          'product-review-form__section-toggle--open': _ctx.isRecoSectionOpen
        }]),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isRecoSectionOpen = !_ctx.isRecoSectionOpen))
                  }, _toDisplayString(_ctx.$t('ads.reviews.form.addMoreInfo')), 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              _cache[31] || (_cache[31] = _createTextVNode()),
              (_ctx.initialModel.wine && _ctx.isRecoSectionOpen)
                ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('ads.reviews.form.recommend')), 1 /* TEXT */),
                      _cache[22] || (_cache[22] = _createTextVNode()),
                      _createVNode(_component_vote_input, {
                        class: "product-review-form__vote",
                        modelValue: _ctx.model.recommendation,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.recommendation) = $event)),
                        name: "recommendation"
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _cache[25] || (_cache[25] = _createTextVNode()),
                    _createVNode(_component_options_list_input, {
                      class: "product-review-form__reco-options product-review-form__reco-options--food",
                      label: _ctx.$t('ads.reviews.form.foodReco'),
                      name: "foodRecommendations",
                      modelValue: _ctx.model.foodRecommendations,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.foodRecommendations) = $event)),
                      multiple: true,
                      options: _ctx.initialModel.foodOptions
                    }, {
                      default: _withCtx((list) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["winefinder__carousel__item", {'winefinder__carousel__item--selected': list.selected}])
                        }, [
                          _createElementVNode("span", _hoisted_18, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["winefinder__carousel__item-icon__icon", list.option.css])
                            }, null, 2 /* CLASS */)
                          ]),
                          _cache[23] || (_cache[23] = _createTextVNode()),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(list.option.label), 1 /* TEXT */)
                        ], 2 /* CLASS */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label", "modelValue", "options"]),
                    _cache[26] || (_cache[26] = _createTextVNode()),
                    _createVNode(_component_options_list_input, {
                      class: "product-review-form__reco-options product-review-form__reco-options--occasion",
                      label: _ctx.$t('ads.reviews.form.occasionReco'),
                      name: "occasions",
                      multiple: true,
                      modelValue: _ctx.model.occasions,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.occasions) = $event)),
                      options: _ctx.initialModel.occasionOptions
                    }, {
                      default: _withCtx((list) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["winefinder__carousel__item", {'winefinder__carousel__item--selected': list.selected}])
                        }, [
                          _createElementVNode("span", _hoisted_20, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["winefinder__carousel__item-icon__icon", list.option.css])
                            }, null, 2 /* CLASS */)
                          ]),
                          _cache[24] || (_cache[24] = _createTextVNode()),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(list.option.label), 1 /* TEXT */)
                        ], 2 /* CLASS */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label", "modelValue", "options"])
                  ]))
                : _createCommentVNode("v-if", true),
              _cache[32] || (_cache[32] = _createTextVNode()),
              (_ctx.captchaConfig)
                ? (_openBlock(), _createBlock(_component_captcha_input, {
                    key: 2,
                    "captcha-site-key": _ctx.captchaConfig.key,
                    "captcha-action": "productReviewForm",
                    ref: "captchaInput",
                    error: _ctx.getErrorText(_ctx.v$.captchaToken.$errors),
                    onChange: _cache[13] || (_cache[13] = ($event) => {_ctx.captchaToken = $event})
                  }, null, 8 /* PROPS */, ["captcha-site-key", "error"]))
                : _createCommentVNode("v-if", true),
              _cache[33] || (_cache[33] = _createTextVNode()),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", _hoisted_23, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t('ads.reviews.form.moreInfo')
                  }, null, 8 /* PROPS */, _hoisted_24),
                  _cache[27] || (_cache[27] = _createTextVNode()),
                  (_ctx.$t('form.mandatory_notice'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('form.mandatory_notice')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _cache[28] || (_cache[28] = _createTextVNode()),
                _createElementVNode("button", {
                  type: "submit",
                  name: "form-button",
                  disabled: _ctx.loading,
                  class: _normalizeClass(["product-review-form__submit-button | button button--primary form__submit-button", {
            'button--loading': _ctx.loading
          }])
                }, _toDisplayString(_ctx.$t('ads.reviews.form.submit')), 11 /* TEXT, CLASS, PROPS */, _hoisted_26)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _cache[44] || (_cache[44] = _createTextVNode()),
        (_ctx.step === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("section", _hoisted_28, [
                _createElementVNode("h3", {
                  class: "product-review-form__headline product-review-form__headline--center",
                  innerHTML: _ctx.successHeadline
                }, null, 8 /* PROPS */, _hoisted_29),
                _cache[41] || (_cache[41] = _createTextVNode()),
                _createElementVNode("div", {
                  class: "product-review-form__ty-subline",
                  innerHTML: _ctx.successSubline
                }, null, 8 /* PROPS */, _hoisted_30),
                _cache[42] || (_cache[42] = _createTextVNode()),
                (_ctx.showSetHint && _ctx.$t('ads.reviews.form.thankYou.setProduct'))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "product-review-form__ty-subline",
                      innerHTML: _ctx.$t('ads.reviews.form.thankYou.setProduct', ['#setContains'])
                    }, null, 8 /* PROPS */, _hoisted_31))
                  : _createCommentVNode("v-if", true),
                _cache[43] || (_cache[43] = _createTextVNode()),
                (_ctx.successState === 'CTACustomer')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('ads.reviews.form.yourReviews')), 1 /* TEXT */),
                      _cache[34] || (_cache[34] = _createTextVNode()),
                      _createElementVNode("a", _hoisted_33, _toDisplayString(_ctx.$t('ads.reviews.form.yourReviews.button')), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_ctx.successState === 'CTAGuest')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('ads.reviews.form.login')), 1 /* TEXT */),
                        _cache[36] || (_cache[36] = _createTextVNode()),
                        _createElementVNode("a", _hoisted_35, _toDisplayString(_ctx.$t('ads.reviews.form.login.button')), 1 /* TEXT */),
                        _cache[37] || (_cache[37] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('ads.reviews.form.teaser.head')), 1 /* TEXT */),
                          _cache[35] || (_cache[35] = _createTextVNode()),
                          _createElementVNode("div", {
                            innerHTML: _ctx.$t('ads.reviews.form.teaser.content')
                          }, null, 8 /* PROPS */, _hoisted_37)
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_ctx.successState === 'CTARegister')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('ads.reviews.form.register')), 1 /* TEXT */),
                          _cache[39] || (_cache[39] = _createTextVNode()),
                          _createElementVNode("a", _hoisted_39, _toDisplayString(_ctx.$t('ads.reviews.form.register.button')), 1 /* TEXT */),
                          _cache[40] || (_cache[40] = _createTextVNode()),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('ads.reviews.form.teaser.head')), 1 /* TEXT */),
                            _cache[38] || (_cache[38] = _createTextVNode()),
                            _createElementVNode("div", {
                              innerHTML: _ctx.$t('ads.reviews.form.teaser.content')
                            }, null, 8 /* PROPS */, _hoisted_41)
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}